export default {
  'accessories.general.form.description': 'Accessory Description',
  'accessories.modal.remove.title': 'Remove Accessory',
  'accessories.modal.remove.content': 'Do you want to remove the accessory',
  'accessories.modal.remove.button.ok': 'Remove',
  'accessories.modal.remove.message.success': 'Accessory successfully removed!',
  'accessories.modal.remove.message.error': 'Unable to remove accessory!',
  'accessories.page.button.new': 'New Accessory',
  'accessories.modal.create.title': 'Add Accessory',
  'accessories.modal.edit.title': 'Update Accessory',
  'accessories.modal.create.message.success': 'Accessory successfully added!',
  'accessories.modal.edit.message.success': 'Accessory successfully updated!',
  'accessories.modal.message.error': 'Unable to execute the action!',
  'accessories.modal.checklist': 'Checklist',

  'accessories.status.message.success':
    'Accessory status changed successfully!',
};
